import { render, staticRenderFns } from "./XTS.vue?vue&type=template&id=51766fb5&scoped=true&"
import script from "./XTS.vue?vue&type=script&lang=js&"
export * from "./XTS.vue?vue&type=script&lang=js&"
import style0 from "./XTS.vue?vue&type=style&index=0&id=51766fb5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51766fb5",
  null
  
)

export default component.exports